var _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pdf-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.676,
    height: 28.261,
    viewBox: "0 0 21.676 28.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23310",
    "data-name": "Path 23310",
    d: "M21.781,0H7.233C6.828,0,6.5.328,6.5.965v26.6a.755.755,0,0,0,.733.5H27.321a.755.755,0,0,0,.733-.5V6.506c0-.349-.047-.461-.129-.544L22.093.129A.443.443,0,0,0,21.781,0Z",
    transform: "translate(-6.379 0)",
    fill: "#e9e9e0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23311",
    "data-name": "Path 23311",
    d: "M37.5.151v5.94h5.94Z",
    transform: "translate(-21.839 -0.075)",
    fill: "#d9d7ca"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23312",
    "data-name": "Path 23312",
    d: "M18.469,20.15h0a.8.8,0,0,1-.485-.163,1.2,1.2,0,0,1-.559-1.124c.091-.816,1.1-1.67,3-2.54a33.648,33.648,0,0,0,1.9-5.389c-.5-1.089-.987-2.5-.632-3.33a.962.962,0,0,1,.568-.609,2.461,2.461,0,0,1,.509-.086c.253,0,.475.325.632.526s.483.588-.187,3.41a16.018,16.018,0,0,0,2.55,3.791,9.752,9.752,0,0,1,1.683-.179c.785,0,1.261.183,1.455.56a1.015,1.015,0,0,1-.2,1.083,1.332,1.332,0,0,1-1.113.6,3.332,3.332,0,0,1-2.111-1.145,24.018,24.018,0,0,0-4.425,1.415,14.223,14.223,0,0,1-1.195,2.131C19.351,19.814,18.907,20.15,18.469,20.15ZM19.8,17.58c-1.071.6-1.508,1.1-1.539,1.375-.005.046-.019.167.216.347C18.555,19.279,18.991,19.08,19.8,17.58Zm6.836-2.227c.409.314.508.473.775.473a.756.756,0,0,0,.607-.221.793.793,0,0,0,.115-.208c-.062-.033-.143-.1-.589-.1A7.329,7.329,0,0,0,26.639,15.353Zm-3.745-3.3a35.737,35.737,0,0,1-1.34,3.792,25.046,25.046,0,0,1,3.256-1.013A17.159,17.159,0,0,1,22.895,12.054Zm-.3-4.242a1.2,1.2,0,0,0,.048,1.612C23.114,8.364,22.612,7.805,22.59,7.812Z",
    transform: "translate(-11.824 -3.445)",
    fill: "#cc4b4c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23317",
    "data-name": "Path 23317",
    d: "M27.321,47.522H7.233a.733.733,0,0,1-.733-.733V39H28.055v7.788A.733.733,0,0,1,27.321,47.522Z",
    transform: "translate(-6.5 -19.261)",
    fill: "#cc4b4c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7228",
    "data-name": "Group 7228",
    transform: "translate(4.755 21.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23314",
    "data-name": "Path 23314",
    d: "M16.567,47.975h-.823V42.924H17.2a2.039,2.039,0,0,1,.637.1,1.733,1.733,0,0,1,.565.308,1.61,1.61,0,0,1,.4.5,1.376,1.376,0,0,1,.154.655,1.791,1.791,0,0,1-.13.7,1.454,1.454,0,0,1-.363.524,1.637,1.637,0,0,1-.562.329,2.162,2.162,0,0,1-.726.116h-.61v1.823Zm0-4.427v2h.754a.9.9,0,0,0,.3-.052.751.751,0,0,0,.271-.168.821.821,0,0,0,.2-.325,1.541,1.541,0,0,0,.075-.517,1.4,1.4,0,0,0-.034-.284.821.821,0,0,0-.14-.308.831.831,0,0,0-.3-.247,1.108,1.108,0,0,0-.507-.1h-.617Z",
    transform: "translate(-15.744 -42.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23315",
    "data-name": "Path 23315",
    d: "M28.162,45.309a3.711,3.711,0,0,1-.134,1.066,2.649,2.649,0,0,1-.339.74,1.743,1.743,0,0,1-.463.47,2.321,2.321,0,0,1-.5.257,2.052,2.052,0,0,1-.439.11,2.921,2.921,0,0,1-.295.023H24.084V42.924h1.521a2.891,2.891,0,0,1,1.12.2,2.326,2.326,0,0,1,.8.538,2.208,2.208,0,0,1,.476.764A2.53,2.53,0,0,1,28.162,45.309Zm-2.44,2.063a1.362,1.362,0,0,0,1.206-.534,2.713,2.713,0,0,0,.37-1.549,2.624,2.624,0,0,0-.075-.624,1.334,1.334,0,0,0-.291-.558,1.537,1.537,0,0,0-.586-.4,2.523,2.523,0,0,0-.959-.154h-.48v3.824Z",
    transform: "translate(-19.903 -42.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23316",
    "data-name": "Path 23316",
    d: "M35.434,43.548v1.59h2.111V45.7H35.434v2.275H34.6V42.924h3.159v.624Z",
    transform: "translate(-25.147 -42.924)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.83f7ae33aee946e27b3092f2ef7c36d5.svg";
export { ForwardRef as ReactComponent };